/**
 * 登录页底部的线路徽标：一个小圆点 + 线路名 + 延迟，点开可以手动换线。
 * 平时用户不用管它 —— 自动选线；它存在是为了出问题时有地方看、有地方点。
 */

import { useState } from 'react'

import type { LineState } from '../lib/useLine'

export function LineBadge({ line }: { line: LineState }) {
  const [open, setOpen] = useState(false)
  if (!line.enabled) return null
  const cur = line.current
  const p = cur ? line.probes.find((x) => x.id === cur.id) : undefined
  const tone = line.busy ? 'busy' : line.allDown ? 'down' : p?.ok ? 'ok' : 'unknown'
  const text = line.busy
    ? '正在检测线路…'
    : line.allDown
      ? '所有线路都连不上'
      : `${cur?.name ?? '线路'}${p?.ok ? ` · ${p.rtt}ms` : ''}${line.pinned ? '（手动）' : ''}`

  return (
    <div className="line-badge">
      <button type="button" className={`line-cur ${tone}`} onClick={() => setOpen((v) => !v)} title="切换线路">
        <span className="line-dot" />
        {text}
      </button>
      {open && (
        <div className="line-menu" role="menu">
          <button type="button" className={line.pinned ? '' : 'on'} onClick={() => { setOpen(false); void line.pick(null) }}>
            自动选择
          </button>
          {line.list.map((s) => {
            const q = line.probes.find((x) => x.id === s.id)
            return (
              <button type="button" key={s.id} className={line.pinned === s.id ? 'on' : ''}
                onClick={() => { setOpen(false); void line.pick(s.id) }}>
                <span className={`line-dot ${q ? (q.ok ? 'ok' : 'down') : 'unknown'}`} />
                {s.name}
                <span className="line-rtt">{q ? (q.ok ? `${q.rtt}ms` : '不通') : ''}</span>
              </button>
            )
          })}
          <button type="button" className="line-refresh" onClick={() => void line.refresh()} disabled={line.busy}>
            重新检测
          </button>
        </div>
      )}
    </div>
  )
}
